/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PolicyHistoryPolicyType {
    CUT_SELECTION = 'cutSelection',
    WEIGHTING = 'weighting',
}
